export const cardholderHeaders = [
  { label: 'Account ID', key: 'accountId' },
  { label: 'Cardholder ID', key: 'id' },
  { label: 'User Name', key: 'username' },
  { label: 'Company ID', key: 'companyId' },
  { label: 'Primary Processor Reference', key: 'primaryProcessorReference' },
  { label: 'External Tag', key: 'externalTag' },
  { label: 'Created At', key: 'createdAt' },
];
